/* touchscreens.com.pk — storefront interactions. Vanilla, no dependencies. */
(function () {
  'use strict';
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  function closeMegas(except) {
    $$('[data-ts-mega]').forEach(function (m) {
      if (m === except) return;
      m.removeAttribute('data-open');
      var btn = $('[data-ts-menu="' + m.getAttribute('data-ts-mega') + '"]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  function closeOverlays() {
    $$('[data-ts-overlay]').forEach(function (o) { o.removeAttribute('data-open'); });
    $$('[data-ts-sheet]').forEach(function (o) { o.removeAttribute('data-open'); });
    d.documentElement.style.overflow = '';
  }

  function openOverlay(el) {
    closeOverlays();
    if (!el) return;
    el.setAttribute('data-open', '');
    d.documentElement.style.overflow = 'hidden';
    var f = el.querySelector('input,button,a');
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
  }

  function showTab(key, scope) {
    var root = scope || d;
    $$('[data-ts-tab]', root).forEach(function (b) {
      if (b.hasAttribute('role')) b.setAttribute('aria-selected', b.getAttribute('data-ts-tab') === key ? 'true' : 'false');
    });
    $$('[data-ts-tabpanel]', root).forEach(function (p) {
      if (p.getAttribute('data-ts-tabpanel') === key) { p.setAttribute('data-open', ''); } else { p.removeAttribute('data-open'); }
    });
  }

  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var menu = t.closest('[data-ts-menu]');
    if (menu) {
      e.preventDefault();
      var key = menu.getAttribute('data-ts-menu');
      var panel = $('[data-ts-mega="' + key + '"]');
      var open = panel && panel.hasAttribute('data-open');
      closeMegas();
      if (panel && !open) { panel.setAttribute('data-open', ''); menu.setAttribute('aria-expanded', 'true'); }
      return;
    }

    var opener = t.closest('[data-ts-open]');
    if (opener) {
      e.preventDefault();
      openOverlay($('[data-ts-overlay="' + opener.getAttribute('data-ts-open') + '"]') || $('[data-ts-sheet="' + opener.getAttribute('data-ts-open') + '"]'));
      return;
    }
    if (t.closest('[data-ts-close]') || t.closest('[data-ts-scrim]')) { e.preventDefault(); closeOverlays(); return; }

    var acc = t.closest('[data-ts-acc]');
    if (acc) {
      e.preventDefault();
      var body = d.getElementById(acc.getAttribute('aria-controls'));
      if (body) {
        var isOpen = body.hasAttribute('data-open');
        if (isOpen) { body.removeAttribute('data-open'); } else { body.setAttribute('data-open', ''); }
        acc.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        var g = acc.querySelector('[data-ts-glyph]');
        if (g) g.textContent = isOpen ? '+' : '–';
      }
      return;
    }

    /* tabs — works from the tab strip and from any in-page link carrying data-ts-tab */
    var tab = t.closest('[data-ts-tab]');
    if (tab) {
      e.preventDefault();
      var wrap = tab.closest('[data-ts-tabs]');
      var scope = wrap ? wrap.parentNode : d;
      showTab(tab.getAttribute('data-ts-tab'), scope);
      var anchor = d.getElementById('ts-specs');
      if (!wrap && anchor) window.scrollTo({ top: anchor.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
      closeMegas();
      return;
    }

    var th = t.closest('[data-ts-thumb]');
    if (th) {
      e.preventDefault();
      var g2 = th.closest('[data-ts-gallery]');
      $$('[data-ts-thumb]', g2).forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      th.setAttribute('aria-current', 'true');
      var big = $('[data-ts-main] img', g2);
      var src = th.getAttribute('data-src');
      if (big && src) { big.src = src; big.srcset = ''; big.alt = th.getAttribute('data-alt') || big.alt; }
      return;
    }

    var chip = t.closest('[data-ts-chip]');
    if (chip) {
      e.preventDefault();
      var grp = chip.closest('[data-ts-chipgroup]');
      $$('[data-ts-chip]', grp).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      chip.setAttribute('aria-pressed', 'true');
      var field = grp.getAttribute('data-ts-chipgroup');
      $$('[data-ts-qbfield="' + field + '"]').forEach(function (inp) { inp.value = chip.getAttribute('data-value') || chip.textContent.trim(); });
      return;
    }

    var fab = t.closest('[data-ts-fab]');
    if (fab) {
      e.preventDefault();
      var m = $('[data-ts-fabmenu]');
      if (!m) return;
      var isOn = m.hasAttribute('data-open');
      if (isOn) { m.removeAttribute('data-open'); } else { m.setAttribute('data-open', ''); }
      fab.setAttribute('aria-expanded', isOn ? 'false' : 'true');
      fab.innerHTML = isOn ? fab.getAttribute('data-glyph') : '×';
      return;
    }
    if (!t.closest('[data-ts-fabmenu]')) {
      var fm = $('[data-ts-fabmenu]');
      if (fm && fm.hasAttribute('data-open')) {
        fm.removeAttribute('data-open');
        var fb = $('[data-ts-fab]');
        if (fb) { fb.setAttribute('aria-expanded', 'false'); fb.innerHTML = fb.getAttribute('data-glyph'); }
      }
    }

    if (!t.closest('[data-ts-mega]') && !t.closest('.ts-head')) closeMegas();
  }, false);

  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMegas(); closeOverlays(); }
  });

  d.addEventListener('click', function (e) {
    var j = e.target.closest && e.target.closest('[data-ts-jump]');
    if (!j) return;
    var target = d.getElementById(j.getAttribute('data-ts-jump'));
    if (!target) return;
    e.preventDefault();
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - 80, behavior: 'smooth' });
    var first = target.querySelector('input:not([type=hidden])');
    if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (err) { first.focus(); } }, 450);
  });

  function stampForms() {
    $$('form[data-ts-rfq]').forEach(function (f) {
      var u = f.querySelector('[data-ts-url]');
      if (u && !u.value) u.value = window.location.href;
      var r = f.querySelector('[data-ts-ref]');
      if (r && !r.value) r.value = d.referrer || 'direct';
    });
  }

  /* ---- smart search: turn a plain multi-word query into an OR + prefix query so
     partial / multi-term searches (e.g. "samsung interactive") return the right
     products ranked first, instead of Shopify's default exact-AND giving 0 hits ---- */
  var TS_STOP = { for: 1, the: 1, and: 1, 'with': 1, a: 1, an: 1, to: 1, of: 1, 'in': 1, on: 1, or: 1 };
  function tsSmartQuery(raw) {
    var out = [];
    (raw || '').trim().split(/\s+/).forEach(function (t) {
      var w = t.replace(/["*()]/g, '');
      if (!w) return;
      if (w.length >= 2 && !TS_STOP[w.toLowerCase()]) out.push(w + '*'); else out.push(w);
    });
    return out.join(' OR ');
  }
  function tsIsAdvanced(q) { return /(\bOR\b|\bAND\b|\bNOT\b|[*":])/.test(q || ''); }

  d.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute) return;
    if ((f.getAttribute('action') || '').indexOf('/search') === -1) return;
    var qi = f.querySelector('input[name="q"]');
    if (!qi || !qi.value.trim()) return;
    var raw = qi.value.trim();
    if (tsIsAdvanced(raw)) return;
    var smart = tsSmartQuery(raw);
    if (!smart || smart === raw) return;
    qi.value = smart;
    if (!f.querySelector('input[name="type"]')) { var ti = d.createElement('input'); ti.type = 'hidden'; ti.name = 'type'; ti.value = 'product'; f.appendChild(ti); }
    if (!f.querySelector('input[name="sq"]')) { var sqf = d.createElement('input'); sqf.type = 'hidden'; sqf.name = 'sq'; sqf.value = raw; f.appendChild(sqf); }
  }, true);

  function init() {
    stampForms();

    /* smart-search: keep the visible query clean, and self-heal searches that
       arrive by direct link or a "popular search" chip (bypassing the form) */
    if (location.pathname.indexOf('/search') === 0 && window.URLSearchParams) {
      var sp = new URLSearchParams(location.search);
      var rawq = sp.get('q') || '';
      var cleanq = sp.get('sq');
      if (cleanq !== null) {
        $$('input[name="q"]').forEach(function (i) { i.value = cleanq; });
      } else if (rawq && !tsIsAdvanced(rawq)) {
        var sm = tsSmartQuery(rawq);
        if (sm && sm !== rawq) {
          sp.set('q', sm); sp.set('sq', rawq);
          if (!sp.get('type')) sp.set('type', 'product');
          location.replace(location.pathname + '?' + sp.toString());
          return;
        }
      }
    }

    /* PDP: correct product image aspect ratio (the <img> carries width/height attrs,
       so width:100% without height:auto stretches it vertically) */
    if ($('.ts-pdp__main img') && !d.getElementById('ts-pdp-imgfix')) {
      var st = d.createElement('style');
      st.id = 'ts-pdp-imgfix';
      st.textContent = '.ts .ts-pdp__main img{height:auto;max-height:420px;object-fit:contain}';
      d.head.appendChild(st);
    }

    /* keep the fixed contact dock at the same spot site-wide; lift it only while
       the sticky product bar is actually on screen (it is hidden until the RFQ
       form scrolls away, so on load the dock matches every other page) */
    var sticky = $('[data-ts-stickybar]');
    var dock = $('.ts-dock');
    var fab = $('.ts-fab');

    var liftDock = function (on) {
      if (dock) dock.style.bottom = on ? '88px' : '';
      if (fab) fab.style.bottom = on ? 'calc(84px + env(safe-area-inset-bottom))' : '';
    };

    /* reveal the sticky bar only once the inline RFQ form has scrolled away */
    var anchor = $('#ts-rfq');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      sticky.style.transform = 'translateY(110%)';
      sticky.style.transition = 'transform .25s ease';
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var show = !en.isIntersecting;
          sticky.style.transform = show ? 'translateY(0)' : 'translateY(110%)';
          liftDock(show);
        });
      }, { rootMargin: '-90px 0px 0px 0px' }).observe(anchor);
    }

    /* if a shopper landed on #ts-specs, open the specifications tab */
    if (window.location.hash === '#ts-specs') showTab('specs', d);

    /* scroll a successful or errored form response into view */
    var flash = $('.ts-rfq__ok, .ts-rfq__err');
    if (flash) {
      window.scrollTo({ top: flash.getBoundingClientRect().top + window.pageYOffset - 120, behavior: 'smooth' });
      try { flash.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
